import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { totalUnreadMessages } from '../../redux/channels/selectors'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import UnreadBadge, { IProps } from './UnreadBadge'

const selector = createStructuredSelector({
  unreadCount: totalUnreadMessages,
})
const actions = {}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, UnreadBadge)
